<template>
  <div
    v-for="(notification, notificationIndex) in notifications"
    :key="notification.id"
    v-show="notificationIndex < 2"
    class="notification"
    :class="`notification-color-${notification.severity}`"
  >
    <span
      v-html="notification.message"
      class="notification-message"
    ></span>
    <button
      type="button"
      title="Close"
      class="dismiss-button"
      @click="removeNotification({ notification })"
    ><i class="fas fa-fw fa-times"></i></button>
  </div>
</template>

<script setup>
  import { useNotifications } from '@/composables/useNotifications';

  const {
    notifications,
    removeNotification
  } = useNotifications();
</script>

<style>
  .notification {
    margin: 0px;
    padding: 8px 20px;
    border-top-width: 1px;
    border-top-style: solid;
    border-right: none;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    border-left: none;
    line-height: 1.25;
    font-size: 16px;
    font-weight: 400;
    color: white;
    position: relative;
  }

  .notification-color-5 {
    background-color: #b3000c;
    border-top-color: #99000a;
    border-bottom-color: #99000a;
  }

  .notification-color-4 {
    background-color: #219155;
    border-top-color: #1e824c;
    border-bottom-color: #1e824c;
  }

  .notification-color-3 {
    background-color: #3281d0;
    border-top-color: #2666a6;
    border-bottom-color: #2666a6;
  }

  .notification-color-2 {
    background-color: #1259a1;
    border-top-color: #0d4073;
    border-bottom-color: #0d4073;
  }

  .notification-color-1 {
    background-color: #657281;
    border-top-color: #5a6672;
    border-bottom-color: #5a6672;
  }

  .notification-color-0 {
    background-color: #383f47;
    border-top-color: #434c56;
    border-bottom-color: #434c56;
  }

  .notification-message a {
    display: inline-block;
    font-weight: 700;
    text-decoration: underline;
    color: white;
  }

  .notification-message a:hover,
  .notification-message a:active,
  .notification-message a:focus {
    color: #dfe7ec;
  }

  .notification-message button {
    display: inline-block;
    margin: 0px 10px;
    padding: 6px 10px;
    white-space: nowrap;
    touch-action: manipulation;
    user-select: none;
    transition: all 500ms ease;
    background-color: rgba(255, 255, 255, 0.35);
    border: 1px solid rgba(255, 255, 255, 0.25);
    border-radius: 2px;
    line-height: 1.0;
    font-size: 14px;
    font-weight: 700;
    font-family: 'Roboto Condensed', 'Lato', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    color: white;
  }

  .notification-message button:hover,
  .notification-message button:active,
  .notification-message button:focus {
    background-color: rgba(255, 255, 255, 0.5);
  }

  .dismiss-button {
    position: absolute;
    top: 2px;
    right: 5px;
    padding: 0px;
    appearance: none;
    background: none;
    border: none;
    text-shadow: none;
    line-height: 1.0;
    font-size: 18px;
    font-weight: bold;
    color: #eff3f5;
    opacity: 0.5;
    float: right;
  }

  .dismiss-button:hover,
  .dismiss-button:active,
  .dismiss-button:focus {
    opacity: 1.0;
  }

  .dismiss-button i {
    width: auto;
  }

  .notification-message span.label {
    padding: 3px 6px;
    border-radius: 0px;
    font-weight: 900;
    display: inline;
    font-size: 75%;
    line-height: 1;
    color: white;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
  }

  .notification-message span.label.label-danger {
    background-color: #cc000e;
  }

  .notification-message span.label.label-warning {
    background-color: #f9690e;
  }

  .notification-message span.label.label-info {
    background-color: #3281d0;
  }

  .notification-message span.label.label-success {
    background-color: #219155;
  }

  .notification-message span.label.label-primary {
    background-color: #0f4d8a;
  }

  .notification-message span.label.label-default {
    background-color: #707f8f;
  }

  @media (max-width: 991px) {
    .notification-message button {
      display: block;
      margin: 10px auto 0px auto;
    }
  }
</style>
